import React from 'react';
import { string, node } from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core';
import Zoom from '@material-ui/core/Zoom';

import Info from '../svg/Info';

const styles = {
  icon: {
    display: 'inline-flex',
    cursor: 'pointer',
  },
};

const arrowGenerator = (color) => ({
  '&[x-placement*="bottom"] $arrow': {
    top: 0,
    left: 0,
    marginTop: '-0.95em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '0 1em 1em 1em',
      borderColor: `transparent transparent ${color} transparent`,
    },
  },
  '&[x-placement*="top"] $arrow': {
    bottom: 0,
    left: 0,
    marginBottom: '-0.95em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '1em 1em 0 1em',
      borderColor: `${color} transparent transparent transparent`,
    },
  },
  '&[x-placement*="right"] $arrow': {
    left: 0,
    marginLeft: '-0.95em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 1em 1em 0',
      borderColor: `transparent ${color} transparent transparent`,
    },
  },
  '&[x-placement*="left"] $arrow': {
    right: 0,
    marginRight: '-0.95em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 0 1em 1em',
      borderColor: `transparent transparent transparent ${color}`,
    },
  },
});

const useStyles = makeStyles((theme) => ({
  arrow: {
    position: 'absolute',
    fontSize: 6,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  popperInteractive: arrowGenerator(theme.palette.grey.light),
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontSize: 11,
    padding: '8px',
    position: 'relative',
    textAlign: 'center',
    borderRadius: '4px',
    maxWidth: '245px',
    border: '1px solid',
    borderColor: theme.palette.grey.light,
    boxShadow: '0px 2px 5px 0px rgba(218,218,218,0.71)',
  },
  tooltipPlacementLeft: {
    margin: '0 8px',
  },
  tooltipPlacementRight: {
    margin: '0 8px',
  },
  tooltipPlacementTop: {
    margin: '8px 0',
  },
  tooltipPlacementBottom: {
    margin: '8px 0',
  },
}));

const ArrowTooltip = (props) => {
  const { arrow, ...classes } = useStyles();
  const [arrowRef, setArrowRef] = React.useState(null);

  return (
    <Tooltip
      classes={classes}
      PopperProps={{
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(arrowRef),
              element: arrowRef,
            },
          },
        },
      }}
      {...props}
      title={
        <React.Fragment>
          {props.title}
          <span className={arrow} ref={setArrowRef} />
        </React.Fragment>
      }
    >
      {props.children}
    </Tooltip>
  );
};

ArrowTooltip.propTypes = {
  title: node.isRequired,
  children: node.isRequired,
};

ArrowTooltip.defaultProps = {};

const MaterialTooltip = ({ tip, placement }) => (
  <ArrowTooltip interactive title={tip} placement={placement} TransitionComponent={Zoom}>
    <div style={styles.icon}>
      <Info />
    </div>
  </ArrowTooltip>
);

MaterialTooltip.propTypes = {
  tip: string.isRequired,
  placement: string,
};

MaterialTooltip.defaultProps = {
  placement: 'top',
};

export default MaterialTooltip;
